<<template>
  <div class="detail-panel">
    <div class="btn-panel">
        <a v-if="this.action != 'View'" class="btn btn-default" @click="save">{{$rs["btn_save"]}}</a>
      <slot></slot>
    </div>
    <hr>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["companyNo"]}}</span>
          <select class="form-control" v-model="data.companyNo">
            <option v-for="(item, idx) in config.company" :value='item.value'>{{item.text}}</option>
          </select>
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3" >
          <span class="input-group-addon" >{{rs["rq"]}}</span>
          <input type="text" class="form-control" readonly v-model="data.rq" >
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["bh"]}}</span>
          <input type="number" class="form-control"  v-bind:readonly='action=="View"' v-model="data.bh"  oninput="if(value.length>6)value=value.slice(0,6)" >
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["xm"]}}</span>
          <input type="text" class="form-control" v-bind:readonly='action=="View"' v-model="data.xm" maxlength="20">
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["checkProject"]}}</span>
          <textarea v-bind:readonly='action=="View"' v-model="data.checkProject"
          rows="2" cols="30" type="text" class="form-control" />
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["checkResult"]}}</span>
          <textarea v-bind:readonly='action=="View"' v-model="data.checkResult"
          rows="2" cols="30" type="text" class="form-control" />
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["health"]}}</span>
          <textarea v-bind:readonly='action=="View"' v-model="data.health"
          rows="2" cols="30" type="text" class="form-control" />
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["dept"]}}</span>
          <input type="text" class="form-control"  v-bind:readonly='action=="View"' v-model="data.dept" maxlength="120">
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["doctor"]}}</span>
          <input type="text" class="form-control"  v-bind:readonly='action=="View"' v-model="data.doctor" maxlength="50">
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["checkPay"]}}</span>
          <input type="number" class="form-control"  v-bind:readonly='action=="View"' v-model="data.checkPay" maxlength="50">
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["remark"]}}</span>
          <textarea v-bind:readonly='action=="View"' v-model="data.remark"
          rows="2" cols="30" type="text" class="form-control" />
        </div>
    </div>
    
  </div>
</template>

<script>
import mixin from "@/fui/mixin";
export default {
  created(){
    this.data.rq =  this.formatter.fdate(this.data.rq);
  },
  methods: {
    checkInput(){
       if (!this.checkNull(this.data.bmbh, "nullId")) return false 
       if (!this.checkNull(this.data.bmmc, "nullName")) return false 
       return true
    }
  },
  mixins: [mixin.detail]
}
</script>


